var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldingBooksIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.2167,
    cy: 85.4335,
    r: 6.87291,
    fill: "#223BF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.3842 84.1293C83.5155 83.9285 84.6929 83.3215 84.8849 82.0514",
    stroke: "white",
    strokeWidth: 0.8125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.348 74.2956L110.994 76.0532C110.511 76.0715 110.151 76.5047 110.221 76.9829L111.353 84.7077C111.414 85.1201 111.776 85.4199 112.193 85.4016L157.414 83.4163C157.849 83.3972 158.191 83.0394 158.191 82.6045V75.1076C158.191 74.6468 157.809 74.2782 157.348 74.2956Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.668 55.709L112.858 56.9997C112.397 57.0121 112.039 57.4054 112.07 57.8656L112.409 62.9867C112.438 63.4258 112.812 63.762 113.252 63.7448L160.721 61.8903C161.157 61.8732 161.502 61.5148 161.502 61.0784L161.502 56.5213C161.502 56.0639 161.125 55.6967 160.668 55.709Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.73 146.094C110.025 152.869 101.045 175.618 94.6009 185.684C94.2083 186.297 93.332 186.075 93.2906 185.348C92.7099 175.146 97.3541 157.797 85.8551 158.378C73.5714 158.999 78.3428 183.938 61.2877 171.158C44.2325 158.378 73.1341 160.5 71.1057 151.457C69.0772 142.413 42.7073 162.191 37.6361 154.753C32.5649 147.315 47.7784 146.301 52.8495 135.821C57.9207 125.34 44.9545 125.243 32.1396 132.486C19.3509 139.714 20.2158 116.209 44.0852 117.213C44.1798 117.217 44.287 117.242 44.3748 117.278C52.2122 120.442 41.0169 107.215 35.9758 104.19C30.9047 101.148 20.3529 91.9802 34.5937 86.4614C48.8345 80.9425 49.6573 121.38 63.7992 134.832C77.9411 148.284 93.0719 137.127 102.73 146.094Z",
    fill: "#1CDBCA",
    stroke: "#1CDBCA",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.764 49.5638L113.103 46.0071C112.664 45.9743 112.278 46.2971 112.234 46.735L111.918 49.8388C111.871 50.2953 112.212 50.6997 112.669 50.7317L160.068 54.041C160.474 54.0694 160.839 53.7917 160.92 53.392L161.5 50.5356C161.597 50.0562 161.252 49.6002 160.764 49.5638Z",
    fill: "#6476F7",
    stroke: "#6476F7",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.349 32.9843L112.965 40.3789C112.53 40.4467 112.229 40.8486 112.285 41.2852L112.685 44.4009C112.743 44.8478 113.153 45.1626 113.599 45.1025L161.505 38.6554C161.979 38.5918 162.295 38.1358 162.189 37.6702L161.266 33.6071C161.172 33.1906 160.771 32.9184 160.349 32.9843Z",
    fill: "#A2ECE5",
    stroke: "#A2ECE5",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.152 29.8315L111.268 27.1895C110.828 27.1652 110.45 27.4954 110.413 27.9341L110.156 31.0648C110.119 31.5139 110.454 31.9073 110.904 31.9415L159.101 35.6191C159.577 35.6555 159.982 35.2755 159.976 34.7981L159.92 30.6319C159.914 30.2048 159.579 29.855 159.152 29.8315Z",
    fill: "#909DF9",
    stroke: "#909DF9",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.548 65.0779L116.422 64.3359C115.973 64.3284 115.603 64.686 115.596 65.1346L115.469 72.6526C115.462 73.1115 115.835 73.4857 116.294 73.4787L159.462 72.8138C159.851 72.8078 160.181 72.5267 160.249 72.1435L161.335 66.0324C161.422 65.5401 161.048 65.0864 160.548 65.0779Z",
    fill: "#1CDBCA",
    stroke: "#1CDBCA",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0843 91.3133C83.1601 102.659 124.073 107.555 131.488 102.907C138.857 98.2878 134.963 89.3648 133.985 86.3076C134.671 86.2167 136.079 86.3 136.221 87.3603C136.397 88.6857 136.486 84.9748 137.104 85.1515C137.599 85.2929 138.135 86.6829 138.341 87.3603L139.49 85.1515L140.285 87.3603C140.786 86.4178 141.858 84.6566 142.141 85.1515C142.424 85.6464 142.73 86.8302 142.848 87.3603C143.319 86.2387 144.367 84.2266 144.792 85.1515C145.322 86.3076 150.888 105.386 139.49 113.868C128.59 121.98 93.7014 116.823 89.9021 115.894C93.3205 117.181 121.898 129.025 143.797 137.927C168.885 148.125 168.457 159.385 168.225 165.49L168.221 165.584C168.034 170.527 165.392 178.123 164.627 180.56C166.254 181.125 175.109 182.244 174.639 185.875C174.168 189.505 153.343 185.818 147.233 184.689C147.565 176.753 154.605 162.355 144.792 154.324C136.87 147.842 126.981 146.421 124.284 148.289C122.344 149.633 123.12 152.87 124.274 157.688L124.284 157.726C126.84 168.394 121.598 177.412 120.122 180.56C119.766 181.319 127.575 183.743 126.981 186.532C127.513 187.969 120.848 187.379 119.119 187.379C118.654 187.379 109.217 187.545 103.34 187.379C102.903 183.714 112.12 172.115 108.505 158.739C105.926 149.2 85.9381 140.802 76.7078 134.756C67.4775 128.71 55.5007 122.688 46.371 101.753C39.8151 86.7204 44.1869 66.5121 54.2437 58.658C64.4641 50.6761 77.624 50.0739 91.0703 51.482C97.1796 52.1218 103.357 54.2746 103.755 54.9718C104.154 55.669 102.261 56.8646 102.56 57.3627C102.799 57.7612 103.755 57.848 103.755 58.6578C103.755 59.4676 102.394 58.8607 102.394 59.4676C102.394 60.0281 103.989 60.2783 103.755 61.0487C103.522 61.8192 101.863 61.6904 101.863 61.6904C101.863 61.6904 103.755 63.0425 103.158 63.6389C102.56 64.2353 100.468 63.1408 100.468 63.1408C100.468 63.1408 102.394 65.4916 101.138 65.9426C99.8817 66.3936 93.9069 62.142 81.8566 62.6657C62.4162 63.5106 59.416 78.3364 72.0843 91.3133Z",
    fill: "#223BF4",
    stroke: "#223BF4",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.791 68.1934H148.971C149.428 68.1934 149.798 68.5635 149.798 69.0201C149.798 69.4768 149.428 69.8469 148.971 69.8469H114.791V68.1934Z",
    fill: "#223BF4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.936 75.2002L115.768 85.9188",
    stroke: "#223BF4",
    strokeWidth: 2.4375
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.365 75.0333L120.232 85.6251",
    stroke: "#223BF4",
    strokeWidth: 2.4375
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.377 55.1123L155.678 62.7079",
    stroke: "#223BF4",
    strokeWidth: 2.4375
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.629 48.1133L150.318 52.6204",
    stroke: "#223BF4",
    strokeWidth: 1.625
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.037 48.2988L152.727 52.806",
    stroke: "#223BF4",
    strokeWidth: 1.625
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.369 77.6221C68.66 74.5943 74.7554 77.8721 73.858 82.3132C71.4938 80.6933 70.7173 81.889 68.8791 84.7195L68.8425 84.7758C66.9779 87.6467 59.9404 86.6569 61.1955 85.4915C65.2565 81.7204 62.0781 80.6499 65.369 77.6221Z",
    fill: "#1CDBCA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.539 83.3436C75.0827 84.8557 74.4583 86.2218 72.5871 87.2053C71.5558 84.1589 73.2246 80.6229 75.0985 79.8867C75.4186 80.4568 75.9953 81.8315 75.539 83.3436Z",
    fill: "#1CDBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingBooksIllustration);
export default __webpack_public_path__ + "static/media/holding-books-illustration.f9ded6115b722478a6d025169bfcb9ab.svg";
export { ForwardRef as ReactComponent };